const gitShaVersion = {
  'X-React-Version': `${__GIT_COMMIT_SHA__}`.slice(0, 7),
};

export default gitShaVersion;
